export function flexAlign(layer) {
  if (layer.metadata.alignY === 'top')    return 'flex-start'
  if (layer.metadata.alignY === 'middle') return 'center'
  if (layer.metadata.alignY === 'bottom') return 'flex-end'
}


export function flexJustify(layer) {
  if (layer.metadata.alignX === 'left')   return 'flex-start'
  if (layer.metadata.alignX === 'center') return 'center'
  if (layer.metadata.alignX === 'right')  return 'flex-end'
}


export function filter(layer) {
  if (layer.metadata?.shadow) {
    return `drop-shadow(${shadowStyle(layer)})`
  } else {
    return ''
  }
}


export function opacity(layer) {
  if (typeof layer.metadata?.opacity === 'number') {
    return layer.metadata.opacity
  } else {
    return 1
  }
}


export function shadowStyle(layer) {
  if (!layer.metadata?.shadow) return ''

  const {blur, color, opacity, x, y} = layer.metadata.shadow

  const shadowColor = hexToRgba(color, opacity)
  return `${x}px ${y}px ${blur}px ${shadowColor}`
}



function hexToRgba(hex, opacity) {
  hex = hex.replace(/^#/, '')

  let r, g, b

  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16)
    g = parseInt(hex[1] + hex[1], 16)
    b = parseInt(hex[2] + hex[2], 16)
  } else if (hex.length === 6) {
    r = parseInt(hex.slice(0, 2), 16)
    g = parseInt(hex.slice(2, 4), 16)
    b = parseInt(hex.slice(4, 6), 16)
  }

  const alpha = opacity / 100
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

